import { year } from "../../../misc/helpers";

//Common
const common = {
  "common.appOwner": "MMX",
  "common.copyright": `© nWise ${year}`,
  "common.appName": "Web-App",
  "common.loading": "Wird geladen",
  "common.call": "Anruf",
  "common.answer": "Antworten",
  "common.reject": "Ablehnen",
  "common.callback": "Ruf zurück",
  "common.callagain": "Erneut aufrufen",
  "common.yes": "Ja",
  "common.no": "Nein",
  "common.on": "AUF",
  "common.off": "AUS",
  "common.text": "Text",
  "common.abort": "Abtreibung",
  "common.delete": "Löschen",
  "common.cancel": "Stornieren",
  "common.missedcall": "Verpasster Anruf von",
  "common.save": "Sparen",
  "common.hangup": "Auflegen",
  "common.add": "Hinzufügen",
  "common.firstname": "Vorname",
  "common.lastname": "Nachname",
  "common.sipaddress": "SIP-Adresse",
  "common.email": "Email",
  "common.address": "Adresse",
  "common.city": "Stadt",
  "common.zipcode": "Postleitzahl",
  "common.calling": "Berufung",
  "common.dialer": "Dialer",
  "common.back": "Zurück",
  "common.hide": "Verbergen",
  "common.online": "Online",
  "common.video": "Video",
  "common.audio": "Audio",
  "common.reset": "Zurücksetzen",
  "common.here": "Hier",
  "common.username": "Nutzername",
  "common.password": "Passwort",
  "common.send": "Senden",
  "common.password1": "Passwort",
  "common.password2": "Wiederhole das Passwort",
  "common.phone": "Telefon",
  "common.sip": "SIP-Adresse",
  "common.mobile": "Handy, Mobiltelefon",
  "common.isdn": "ISDN-Nummer",
  "common.3gnumber": "3G-Nummer",
  "common.fax": "Fax",
  "common.username_helptext":
    "Zwischen 5 und 100 Zeichen. Erlaubt sind nur 0-9,. (Punkt), - (Strich) und a-z (Kapitälchen).",
  "common.email_helptext": "",
  "common.password1_helptext": "Zwischen 6 und 20 Zeichen",
  "common.password2_helptext": "Passwörter sind nicht gleich",
  "common.firstname_helptext": "",
  "common.lastname_helptext": "",
  "common.address_helptext": "",
  "common.zipcode_helptext": "",
  "common.city_helptext": "",
  "common.phone_helptext": "",
  "common.sip_helptext": "",
  "common.mobile_helptext": "",
  "common.isdn_helptext": "",
  "common.3gnumber_helptext": "",
  "common.fax_helptext": "",
  "common.link": "Verknüpfung",
  "common.Link": "Verknüpfung",
  "common.anonymous": "Anonym",
  "common.edit": "Bearbeiten",
  "common.contact_information": "Kontaktinformation",
  "common.view_message": "Nachricht ansehen",
  "common.close_message": "Nachricht schließen",
  "common.required": "* Pflichtfeld",
  "common.to_startpage": "Um die Seite zu starten",
  "common.organisation": "Organisation",
};

const titles = {
  "titles.login": "Anmeldung",
  "titles.services": "Dienstleistungen",
  "menu.servicesHeadline": "Dienstleistungen",
  "titles.contacts": "Meine Kontakte",
  "titles.call": "Anruf",
  "titles.messages": "Mitteilungen",
  "titles.settings": "Die Einstellungen",
  "titles.userinformation": "Mein Profil",
  "titles.log": "Debuggen",
  "titles.about": "Informationen zu Systemen",
  "titles.registration": "Anmeldung",
  "titles.newpassword": "Bekomme ein neues Passwort",
  "titles.resetpassword": "Passwort zurücksetzen",
};

const toolbar = {
  "toolbar.hidetext": "Text ist AUS",
  "toolbar.showtext": "Text ist eingeschaltet",
  "toolbar.micoff": "Mikrofon ist ausgeschaltet",
  "toolbar.micon": "Mikrofon ist eingeschaltet",
  "toolbar.audiooff": "Audio ist AUS",
  "toolbar.audioon": "Audio ist eingeschaltet",
  "toolbar.videooff": "Eingehendes Video ist ausgeschaltet",
  "toolbar.videoon": "Eingehendes Video ist eingeschaltet",
  "toolbar.cameraoff": "Mein Video ist ausgeschaltet",
  "toolbar.cameraon": "Mein Video ist eingeschaltet",
  "toolbar.selfviewoff": "Die Selbstansicht ist ausgeschaltet",
  "toolbar.selfviewon": "Die Selbstansicht ist eingeschaltet",
  "toolbar.hidedialpad": "Wählfeld ist eingeschaltet",
  "toolbar.showdialpad": "Wählfeld ist ausgeschaltet",
  "toolbar.useaudioon": "Anruf mit Ton ist eingeschaltet",
  "toolbar.useaudiooff": "Anruf mit Ton ist AUS",
  "toolbar.usevideoon": "Anruf mit Video ist eingeschaltet",
  "toolbar.usevideooff": "Anruf mit Video ist AUS",
  "toolbar.usetexton": "Anruf mit Text ist eingeschaltet",
  "toolbar.usetextoff": "Anruf mit Text ist AUS",
  "toolbar.more": "Mehr",
  "toolbar.hide": "Verbergen",
  "toolbar.togglevideo": "Video anzeigen",
  "toolbar.toggletext": "Text anzeigen",
  "toolbar.toSettings": "Gehen Sie zu den %einstellungen",
};

//Menu
const menu = {
  "menu.logo": "Zur Startseite",
  "menu.services": "Dienstleistungen",
  "menu.servicesHeadline": "Dienstleistungen",
  "menu.contacts": "Kontakte",
  "menu.mycontacts": "Meine Kontakte",
  "menu.call": "Anruf",
  "menu.history": "Geschichte",
  "menu.messages": "Mitteilungen",
  "menu.settings": "Die Einstellungen",
  "menu.logout": "Ausloggen",
  "menu.userinformation": "Konto",
  "menu.userprofile": "Mein Profil",
  "menu.log": "Debuggen",
  "menu.about": "Informationen zu Systemen",
};

//Login screen
const login = {
  "login.loginanonymous.headline": "Klicken Sie hier für anonyme Anrufe",
  "login.loginanonymous": "Anonymer Login",
  "login.headline": "Anmeldung",
  "login.login": "Anmeldung",
  "login.loginfailed": "Anmeldung fehlgeschlagen",
  "login.resetpassword": "Haben Sie Ihr Passwort vergessen?",
  "login.registration": "Möchten Sie sich anmelden?",
  "login.nowebrtc":
    "Ihr Browser unterstützt keine Echtzeitkommunikation mit Video und Audio (WebRTC).",
  "login.debug": "Debug-Modus",
  "login.optinalLogin": "",
  "login.optinalLoginLink": "",
  "login.optinalLoginInfo": "",
  "login.optinalLoginInfoLink": "",
  "login.optinalLogin2": "",
  "login.optinalLoginLink2": "",
  "login.handleData": "",
  "login.handleDataLink": "",
  "login.logo.href": "https://nwise.se/",
  "login.loggedin.logo.href": "#/",
};

//Errors
const error = {
  "error.usernameorpassword": "Ungültiger Benutzername oder Passwort",
  "error.usernameNotExists": "Dieser Nutzername existiert nicht",
  "error.noservercontact": "Kein Kontakt zum Server",
  "error.accountexpired": "Konto abgelaufen",
  "error.tokenexpired":
    "Die Authentifizierungssitzung ist abgelaufen. Melden Sie sich erneut an",
  "error.tokeninvalid": "Das Authentifizierungstoken ist ungültig",
  "error.unknown": "Unbekannter Fehler",
  "error.unknownsender": "Unbekannter Absender",
  "error.unknownsip": "Unbekanntes SIP",
  "error.notextsent": "Kein Text gesendet",
  "error.acquiremedia":
    "Sie können keine Audio- / Videoanrufe tätigen, wenn Sie keinen Zugriff auf Medien zulassen. Wenn Sie ohne Audio / Video anrufen möchten, deaktivieren Sie diese in den Einstellungen.",
  "error.cantcall":
    "Sie können keine Anrufe tätigen, wenn Sie nicht mit dem System in Kontakt sind",
  "error.cantcall_without_media":
    "Ohne Ton, Video oder Text können Sie keine Anrufe tätigen",
  "error.404": "404 - Die von Ihnen gesuchte Seite existiert nicht",
  "error.unsupportedbrowser":
    "Ihr Webbrowser wird derzeit nicht unterstützt. Verwenden Sie einen anderen Webbrowser.",
  "error.browseroutofdate":
    "Ihr Webbrowser ist veraltet. Bitte aktualisieren Sie es auf die neueste Version, um die Anwendung verwenden zu können.",
};

//User settings
const settings = {
  "settings.white": "Weiß",
  "settings.lightgrey": "Hellgrau",
  "settings.darkgrey": "Dunkelgrau",
  "settings.black": "Schwarz",
  "settings.yellow": "Gelb",
  "settings.blue": "Blau",
  "settings.red": "Rot",
  "settings.green": "Grün",
  "settings.purple": "Lila",
  "settings.orange": "Orange",
  "settings.pink": "Rosa",
  "settings.helvetica": "Helvetica",
  "settings.times": "Times New Roman",
  "settings.arial": "Arial",
  "settings.trebuchet": "Trebuchet MS",
  "settings.lucida": "Lucida ohne Unicode",
  "settings.verdana": "Verdana",
  "settings.comicsans": "Comic Sans",
  "settings.couriernew": "Kurier Neu",
  "settings.sidebyside": "Seite an Seite",
  "settings.overunder": "Über und unter",
  "settings.one": "Freigegebenes Textfenster",
  "settings.smartphone": "Smartphone",
  "settings.bell": "Glocke",
  "settings.marimba": "Marimba",
  "settings.glas": "Glas",
  "settings.classic": "Klassisch",
  "settings.settings": "Die Einstellungen",
  "settings.text": "Text",
  "settings.font": "Schriftart",
  "settings.fontsize": "Schriftgröße",
  "settings.textboxlayout": "Textfenster-Layout",
  "settings.mycolors": "Mein Textfenster",
  "settings.incomingcolors": "Eingehendes Textfenster",
  "settings.sharedcolors": "Freigegebenes Textfenster",
  "settings.textcolors": "Textfarbe",
  "settings.backgroundcolors": "Hintergrundfarbe",
  "settings.preview": "Vorschau",
  "settings.loremipsum":
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed tempor und Vitalität, so dass die Arbeit und die Trauer, einige wichtige Dinge eiusmod zu tun.",
  "settings.previewmytext": "Mein Text",
  "settings.previewincomingtext": "Eingehender Text",
  "settings.previewbothtext": "Mein Text, Eingehender Text",
  "settings.incomingcalls": "Eingehende Anrufe",
  "settings.ringsignal": "Rufsignal",
  "settings.messagebox": "Nachrichtenbox",
  "settings.autoanswer": "Verwenden Sie eine SMS, wenn Sie nicht antworten",
  "settings.autoanswermessage": "Die Nachricht",
  "settings.duringcalls": "Während anrufen",
  "settings.colors": "Farben",
  "settings.textformat": "Text",
  "settings.media": "Medien",
  "settings.audio": "Ton",
  "settings.video": "Video",
  "settings.ringtone": "Klingelton",
  "settings.mediamail": "Mitteilungen",
  "settings.about": "System Information",
  "settings.logout": "Ausloggen",
  "settings.logout.anonymous": "Ausloggen",
  "settings.saved": "Einstellungen wurden gespeichert",
  "settings.media_explanation":
    "Mit diesen Einstellungen können Sie auswählen, wie Ihre Anrufe aussehen sollen. Wenn eine dieser Einstellungen auf EIN gesetzt ist, können Sie sie während eines Anrufs immer vorübergehend ausschalten. Wenn sie jedoch AUS ist, kann sie bei einem Anruf nicht eingeschaltet werden.",
  "settings.useaudio": "Rufen Sie mit Ton an",
  "settings.usevideo": "Rufen Sie mit Video an",
};

//Messages
const messages = {
  "messages.messages": "Mitteilungen",
  "messages.unreadmessages": "Ungelesen",
  "messages.readmessages": "Lesen",
  "messages.nomessages": "Du hast keine Nachrichten",
  "messages.deleteallread": "Löschen Sie alle gelesenen Nachrichten",
  "messages.deleteallreadconfirm": "Alle gelesenen Nachrichten löschen?",
  "messages.messageAlert": "Nachricht gelöscht",
};

//Contacts
const contacts = {
  "contacts.contacts": "Meine Kontakte",
  "contacts.addcontact": "Kontakt hinzufügen",
  "contacts.deletecontact": "Kontakt löschen",
  "contacts.nosipgiven": "Bitte geben Sie dem Kontakt eine SIP-Adresse",
};

//Call screen
const call = {
  "call.placeholder": "Geben Sie hier die Nummer / den Namen ein",
  "call.incomingtext": "Eingehender Text",
  "call.outgoingtext": "Ausgehender Text",
  "call.incoming": "Eingehender Anruf von",
  "call.unknownnumber": "unbekannte Nummer",
  "call.unknownnumber_uppercase": "Unbekannte Nummer",
  "call.endedcall": "beendete den Anruf",
  "call.yourejected": "Sie haben den Anruf abgelehnt",
  "call.noanswer": "Keine Antwort",
  "call.rejected": "konnte im Moment nicht antworten",
  "call.notfound": "ist nicht erreichbar",
  "call.toolongtext":
    "\n <Es wurden zu viele Zeichen eingegeben. Max 1000.> \n",
  "call.notificationbody": "Klicken Sie hier, um zu antworten",
  "call.videoTextDisabled": "Text und eingehendes Video ist deaktiviert",
  "call.writeHere": "Hier schreiben...",
  "call.receiveHere": "Hier wird der eingehende Text angezeigt",
  "call.establishing": "Anruf einrichten...",
};

//History screen
const history = {
  "history.history": "Geschichte",
};

//Reset password
const resetpassword = {
  "resetpassword.processing": "Wird bearbeitet ...",
  "resetpassword.completed": "Das Zurücksetzen des Passworts ist abgeschlossen",
  "resetpassword.email_or_username": "E-Mail Adresse oder Benutzername",
  "resetpassword.title": "Neues Kennwort",
  "resetpassword.explanation":
    "Geben Sie Ihre E-Mail oder Ihren Benutzernamen ein und ein Link wird an die E-Mail oder die E-Mail mit dem Benutzernamen gesendet. Folgen Sie dem Link, um Ihr Passwort zurückzusetzen.",
  "resetpassword.explanation_complete":
    "Sie erhalten in Kürze eine E-Mail mit weiteren Anweisungen.",
  "resetpassword.invalid_link":
    "Ungültiger Link zum Zurücksetzen des Kennworts",
  "resetpassword.password_changed": "Ihr Passwort hat sich geändert",
  "resetpassword.enter_new_password": "Neues Passwort eingeben",
  "resetpassword.button_reset": "Zurücksetzen",
  "resetpassword.password": "Passwort",
  "resetpassword.password_repeat": "Wiederhole das Passwort",
  "resetpassword.password_requirement":
    "Das Passwort muss zwischen 6 und 20 Zeichen lang sein",
  "resetpassword.error":
    "Das Passwort konnte nicht zurückgesetzt werden. Bitte versuchen Sie es erneut oder wenden Sie sich an Ihren Administrator.",
};

const registration = {
  "registration.error":
    "Die Registrierung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut oder wenden Sie sich an Ihren Administrator.",
  "registration.title": "Anmeldung",
  "registration.processing": "Wird bearbeitet ...",
  "registration.not_enabled": "Die Registrierung ist nicht aktiviert.",
  "registration.completed_headline": "Sie wurden registriert",
  "registration.completed": "Ihre Registrierung wurde abgeschlossen.",
  "registration.completed_link": "/",
  "registration.username_exists":
    "Benutzername existiert Bitte wählen Sie einen anderen Benutzernamen.",
  "registration.email_exists":
    "Email existiert. Bitte wählen Sie eine andere E-Mail.",
  "registration.sip_exists":
    "SIP-Adresse existiert Bitte wählen Sie eine andere SIP-Adresse.",
  "registration.license1": "Ja ich habe gelesen",
  "registration.license_link_text":
    "die Informationen darüber, wie wir mit persönlichen Informationen umgehen",
  "registration.license2": "und akzeptiere die Bedingungen",
  "registration.licenselink": "https://nwise.se/om-oss/",
  "registration.info": "",
};

const changeuser = {
  "changeuser.title": "Konto bearbeiten",
  "changeuser.titlePassword": "Ändere das Passwort",
  "changeuser.newPassword": "Neues Kennwort",
  "changeuser.error":
    "Update war nicht möglich. Bitte versuchen Sie es erneut oder wenden Sie sich an Ihren Administrator.",
  "changeuser.complete": "Konto aktualisiert",
  "changeuser.processing": "Wird bearbeitet ...",
  "changeuser.username_exists":
    "Benutzername existiert Bitte wählen Sie einen anderen Benutzernamen.",
  "changeuser.email_exists":
    "Email existiert. Bitte wählen Sie eine andere E-Mail.",
  "changeuser.email_empty":
    "E-Mail ist erforderlich. Bitte schreibe eine E-Mail.",
  "changeuser.sip_exists":
    "SIP-Adresse existiert Bitte wählen Sie eine andere SIP-Adresse.",
};

const network = {
  "network.networkError":
    "Beim Verbinden mit dem Server ist ein Problem aufgetreten",
  "network.offline": "Offline",
};

const accessibility = {
  "accessibility.darktheme": "Dunkles Thema",
  "accessibility.originaltheme": "Ursprüngliches Thema",
};

const about = {
  "about.user": "Nutzername",
  "about.sip": "SIP-Adresse",
  "about.server": "Server IP",
  "about.version": "Ausführung",
  "about.browser": "Browser",
  "about.browserversion": "Browser-Version",
  "about.os": "OS",
};

const aria = {
  "aria.mainmenu": "Hauptmenü",
  "aria.submenu_contacts": "Untermenü der Kontakte",
  "aria.submenu_account": "Untermenü des Kontos",
  "aria.selected_page": "Ausgewählte Seite",
  "aria.back_button": "Entferne das letzte Zeichen",
  "aria.accept_terms": "Die Bedingungen akzeptieren",
  "aria.link_sound_video": "Gehen Sie zu den Einstellungen für Ton und Video",
  "aria.selfview": "Selbstansicht Video",
  "aria.in-call": "Im anruf",
};

const en = {
  ...common,
  ...toolbar,
  ...titles,
  ...login,
  ...error,
  ...settings,
  ...menu,
  ...messages,
  ...contacts,
  ...call,
  ...history,
  ...resetpassword,
  ...registration,
  ...changeuser,
  ...network,
  ...accessibility,
  ...about,
  ...aria,
};

export default en;






// WEBPACK FOOTER //
// ./src/branding/default/language/de.js